
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/memories/[mid]",
      function () {
        return require("private-next-pages/memories/[mid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/memories/[mid]"])
      });
    }
  